import { render } from "./TemplateEditor.vue?vue&type=template&id=627f2477&ts=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"

import "./TemplateEditor.vue?vue&type=style&index=0&id=627f2477&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__